module.exports = __webpack_public_path__ + "assets/img/f3dbc285d19b85d98013ee8f1860ec77.svg";